// components/index/index

import template from './template.jade'
import style    from './style.scss'
import Store    from 'Store'

var name = 'index'
const store = new Store(name)

export default {

  name: name,
  template: template({style: style}),

  data: () => ({
    name: name,
    store: store.data,
  }),

}


/** WEBPACK FOOTER **
 ** ./src/js/components/index/index.js
 **/